<template>
  <section>
    <h3>Matrícula Siape {{ value.siape }}</h3>

    <section class="section">
      <h4>Órgão</h4>

      <div class="row">
        <BaseTextInput
          v-bind="orgao.origemNome"
          v-bind:disabled="readonly"
          v-bind:value="value.orgaoOrigemNome"
        />
        <BaseTextInput
          v-bind="orgao.situacaoFuncional"
          v-bind:disabled="readonly"
          v-bind:value="value.situacaoFuncionalNome"
        />
        <BaseTextInput
          v-bind="orgao.cargo"
          v-bind:disabled="readonly"
          v-bind:value="value.cargoNome"
        />
        <BaseTextInput
          v-bind="orgao.classe"
          v-bind:disabled="readonly"
          v-bind:value="value.classeNome"
        />
        <BaseTextInput
          v-bind="orgao.padrao"
          v-bind:disabled="readonly"
          v-bind:value="value.padrao"
        />
        <BaseTextInput
          v-bind="orgao.jornada"
          v-bind:disabled="readonly"
          v-bind:value="value.jornadaNome"
        />
      </div>
    </section>

    <section class="section">
      <h4>Unidades</h4>

      <div class="row">
        <BaseTextInput
          v-bind="unidades.unidadeOrganizacionalLotacao"
          v-bind:disabled="readonly"
          v-bind:value="unidadeOrganizacionalLotacao"
        />
        <BaseTextInput
          v-bind="unidades.unidadeOrganizacionalExercicio"
          v-bind:disabled="readonly"
          v-bind:value="unidadeOrganizacionalExercicio"
        />
        <BaseTextInput
          v-bind="unidades.unidadePagadora"
          v-bind:disabled="readonly"
          v-bind:value="unidadePagadora"
        />
        <BaseTextInput
          v-bind="unidades.lotacao"
          v-bind:disabled="readonly"
          v-bind:value="lotacao"
        />
        <BaseTextInput
          v-bind="unidades.localizacao"
          v-bind:disabled="readonly"
          v-bind:value="localizacao"
        />
      </div>
    </section>

    <section class="section">
      <h4>Regime jurídico</h4>

      <div class="row">
        <BaseTextInput
          v-bind="regimeJuridico.regimeJuridico"
          v-bind:disabled="readonly"
          v-bind:value="regimeJuridicoNome"
        />
        <BaseTextInput
          v-bind="regimeJuridico.ingressoServicoPublicoData"
          v-bind:disabled="readonly"
          v-bind:value="formattedIngressoServicoPublicoData"
        />
        <BaseTextInput
          v-if="temContrato"
          v-bind="regimeJuridico.terminoContratoTemporario"
          v-bind:disabled="readonly"
          v-bind:value="formattedTerminoContratoTemporario"
        />
      </div>
    </section>

    <section class="section">
      <h4>Admissão</h4>

      <div class="row">
        <BaseTextInput
          v-bind="admissao.diplomaLegalNumero"
          v-bind:disabled="readonly"
          v-bind:value="value.admissaoDiplomaLegalNumero"
        />
        <BaseTextInput
          v-bind="admissao.ingressoOrgaoData"
          v-bind:disabled="readonly"
          v-model="formattedIngressoOrgaoData"
        />
        <BaseTextInput
          v-bind="admissao.diplomaLegalData"
          v-bind:disabled="readonly"
          v-bind:value="formattedDiplomaLegalData"
        />
        <BaseTextInput
          v-bind="admissao.diplomaLegalTipo"
          v-bind:disabled="readonly"
          v-bind:value="admissaoDiplomaLegalTipoNome"
        />
      </div>
    </section>
  </section>
</template>

<script>
export default {
  name: "BaseDadoFuncional",
  props: {
    tiposDiplomaLegal: {
      type: Array,
      required: true,
      default: () => []
    },
    regimesJuridicos: {
      type: Array,
      required: true,
      default: () => []
    },
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      readonly: true,
      siape: {
        id: this.buildElementId("siape"),
        label: "Matrícula Siape",
        gridExpression: "col s12 m6"
      },
      orgao: {
        origemNome: {
          id: this.buildElementId("origemnome"),
          label: "Nome do órgão de origem",
          gridExpression: "col s12"
        },
        situacaoFuncional: {
          id: this.buildElementId("situacaofuncional"),
          label: "Situação funcional",
          gridExpression: "col s12 m6"
        },
        cargo: {
          id: this.buildElementId("cargo"),
          label: "Cargo",
          gridExpression: "col s12 m6"
        },
        classe: {
          id: this.buildElementId("classe"),
          label: "Classe",
          gridExpression: "col s12 m3"
        },
        padrao: {
          id: this.buildElementId("padrao"),
          label: "Padrão",
          gridExpression: "col s12 m3"
        },
        jornada: {
          id: this.buildElementId("jornada"),
          label: "Jornada",
          gridExpression: "col s12 m6"
        }
      },
      unidades: {
        unidadeOrganizacionalLotacao: {
          id: this.buildElementId("uorglotacao"),
          label: "Unidade organizacional de lotação",
          gridExpression: "col s12"
        },
        unidadeOrganizacionalExercicio: {
          id: this.buildElementId("uorgexercicio"),
          label: "Unidade organizacional em exercício",
          gridExpression: "col s12"
        },
        unidadePagadora: {
          id: this.buildElementId("upag"),
          label: "Unidade pagadora",
          gridExpression: "col s12"
        },
        lotacao: {
          id: this.buildElementId("lotacao"),
          label: "Lotação",
          gridExpression: "col s12"
        },
        localizacao: {
          id: this.buildElementId("localizacao"),
          label: "Localização",
          gridExpression: "col s12"
        }
      },
      regimeJuridico: {
        regimeJuridico: {
          id: this.buildElementId("regimejuridico"),
          label: "Regime",
          gridExpression: "col s12 m6"
        },
        ingressoServicoPublicoData: {
          id: this.buildElementId("ingressoservicopublico"),
          label: "Ingresso no serviço público",
          gridExpression: "col s12 m6"
        },
        terminoContratoTemporario: {
          id: this.buildElementId("terminocontrato"),
          label: "Término do contrato",
          gridExpression: "col s12"
        }
      },
      admissao: {
        diplomaLegalNumero: {
          id: this.buildElementId("diploma-numero"),
          label: "Número do diploma",
          gridExpression: "col s12 m6"
        },
        ingressoOrgaoData: {
          id: this.buildElementId("admissao"),
          label: "Data da admissão",
          gridExpression: "col s12 m3"
        },
        diplomaLegalData: {
          id: this.buildElementId("diploma-data"),
          label: "Data do diploma",
          gridExpression: "col s12 m3"
        },
        diplomaLegalTipo: {
          id: this.buildElementId("diploma-tipo"),
          label: "Tipo do diploma",
          gridExpression: "col s12"
        }
      }
    };
  },
  computed: {
    toBrazilianDate() {
      return this.$utils.DateTime.toBrazilianDate;
    },
    admissaoDiplomaLegalTipoNome() {
      const obj = (this.tiposDiplomaLegal || []).find(
        item => item.codigo === this.value.admissaoDiplomaLegalTipoCodigo
      );

      return (obj || {}).nome;
    },
    formattedDiplomaLegalData() {
      // Neste componente, exibe-se a data mesmo caso ela seja inválida
      return this.$utils.DateTime.format(
        this.value.admissaoDiplomaLegalData,
        this.toBrazilianDate
      );
    },
    formattedTerminoContratoTemporario() {
      // Neste componente, exibe-se a data mesmo caso ela seja inválida
      return this.$utils.DateTime.format(
        this.value.contratoTemporarioTermino,
        this.toBrazilianDate
      );
    },
    formattedIngressoServicoPublicoData() {
      // Neste componente, exibe-se a data mesmo caso ela seja inválida
      return this.$utils.DateTime.format(
        this.value.ingressoServicoPublicoData,
        this.toBrazilianDate
      );
    },
    formattedIngressoOrgaoData() {
      // Neste componente, exibe-se a data mesmo caso ela seja inválida
      return this.$utils.DateTime.format(
        this.value.ingressoOrgaoData,
        this.toBrazilianDate
      );
    },
    lotacao() {
      const codigo = this.value.lotacaoCodigo || "";
      const nome = this.value.lotacaoNome || "";

      if (!codigo && !nome) {
        return null;
      }

      return `${codigo} - ${nome}`;
    },
    localizacao() {
      const codigo = this.value.localizacaoCodigo || "";
      const nome = this.value.localizacaoNome || "";

      if (!codigo && !nome) {
        return null;
      }

      return `${codigo} - ${nome}`;
    },
    regimeJuridicoServidor() {
      const obj = (this.regimesJuridicos || []).find(
        item => item.codigo === this.value.regimeJuridicoCodigo
      );

      return obj || {};
    },
    regimeJuridicoNome() {
      return this.regimeJuridicoServidor.nome;
    },
    temContrato() {
      return !!this.regimeJuridicoServidor.temContrato;
    },
    unidadeOrganizacionalLotacao() {
      const codigo = this.value.unidadeOrganizacionalLotacaoCodigo || "";
      const nome = this.value.unidadeOrganizacionalLotacaoNome || "";

      if (!codigo && !nome) {
        return null;
      }

      return `${codigo} - ${nome}`;
    },
    unidadeOrganizacionalExercicio() {
      const codigo = this.value.unidadeOrganizacionalExercicioCodigo || "";
      const nome = this.value.unidadeOrganizacionalExercicioNome || "";

      if (!codigo && !nome) {
        return null;
      }

      return `${codigo} - ${nome}`;
    },
    unidadePagadora() {
      let codigo = this.value.unidadePagadoraCodigo || "";
      const nome = this.value.unidadePagadoraNome || "";

      if (!codigo && !nome) {
        return null;
      }

      if (codigo.length >= 3) {
        codigo = codigo.substring(codigo.length - 3);
      }

      return `${codigo} - ${nome}`;
    }
  },
  methods: {
    buildElementId(name) {
      return `dadosfuncionais-dadofuncional-${this.value.id}-${name}`;
    }
  }
};
</script>

<style scoped>
h4 {
  font-size: 1.15rem;
  margin: 0.7666666667rem 0 0.46rem 0;
}

.row {
  margin-bottom: 0;
}
</style>
